import React from 'react';

export default function useMobile(breakPoint?: number) {
    const [isMobile, setMobileBool] = React.useState(false);

    const updateDimensions = () => {
        setMobileBool(window.innerWidth < (breakPoint || 961));
    };

    React.useEffect(() => {
        updateDimensions();

        window.addEventListener('resize', updateDimensions);
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    return isMobile;
}
